import React from 'react';
import { BsTwitter, BsInstagram, BsGithub, BsLinkedin, BsWhatsapp } from 'react-icons/bs';
// import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href='https://twitter.com/aadrian_leo?t=cxH9bivL6X2Rd12fTudnTA&s=09' target='_blank'  rel="noopener noreferrer"><BsTwitter /></a>
    </div>
    <div>
      <a href='https://api.whatsapp.com/send?phone=7977183690' target='_blank'  rel="noopener noreferrer"><BsWhatsapp /></a>
    </div>
    {/* <div>
      <FaFacebookF />
    </div> */}
    <div>
    <a href='https://github.com/AadrianLeo' target='_blank'  rel="noopener noreferrer"><BsGithub /></a>
    </div>
    <div>
    <a href='https://www.instagram.com/aadrian_leo/' target='_blank'  rel="noopener noreferrer"><BsInstagram /></a>
    </div>
    <div>
    <a href='https://www.linkedin.com/in/dharampal-singh-35887721a/' target='_blank'  rel="noopener noreferrer"><BsLinkedin /></a>
    </div>
  </div>
);

export default SocialMedia;